import React, { useCallback, useState } from 'react';
import { Tooltip, TooltipProps } from '@umu/design-base';

interface IOverflowTooltip {
    title: string;
    className?: string;
    onClick?: VoidFunction;
}
// 当内容长度超出容器后才展示 tooltip
export const OverflowTooltip = (props: IOverflowTooltip & TooltipProps) => {
    const { children, className = '', onClick } = props;
    const [hasTooltip, setHasTooltip] = useState<boolean>();

    const wrapRef = useCallback((node: HTMLDivElement) => {
        if (node) {
            setHasTooltip(node.children[0].scrollWidth > node.clientWidth);
        }
    }, []);

    if (hasTooltip) {
        return <Tooltip {...props}>{children}</Tooltip>;
    }
    if (hasTooltip === false) {
        return <div className={className}>{children}</div>;
    }

    return (
        <div className={`overflow-tooltip overflow-hidden ${className}`} ref={wrapRef} onClick={onClick}>
            <span className="inline-block space-nowrap">{children}</span>
        </div>
    );
};
